export const routes = Object.freeze({
  root: {
    title: 'Root',
    pattern: {
      path: '/',
    },
  },
  explore: {
    title: 'Explore',
    fullPath: '/:companyId/explore',
    pattern: {
      path: ':companyId/explore',
    },
  },
  companyData: {
    title: 'Company Data',
    fullPath: '/:companyId/company-data',
    pattern: {
      path: ':companyId/company-data',
    },
  },
  query: {
    title: 'Query',
    fullPath: '/:companyId/query',
    pattern: {
      path: ':companyId/query',
    },
  },
  taskManager: {
    title: 'Task Manager',
    fullPath: '/:companyId/tasks',
    pattern: {
      path: ':companyId/tasks',
    },
  },
  analytics: {
    title: 'Analytics',
    fullPath: '/:companyId/analytics',
    pattern: {
      path: ':companyId/analytics',
    },
  },
  accessManagement: {
    title: 'Access Management',
    fullPath: '/:companyId/access',
    pattern: {
      path: ':companyId/access',
    },
  },
  userSettings: {
    title: 'User Settings',
    fullPath: '/:companyId/usersettings/:settingsPageId',
    pattern: {
      path: '/:companyId/usersettings/:settingsPageId',
    },
  },
  userSettingsTabs: {
    title: 'User Settings Tabs',
    fullPath: '/:companyId/usersettings/:settingsPageId/:settingsPageTabId',
    pattern: {
      path: '/:companyId/usersettings/:settingsPageId/:settingsPageTabId',
    },
  },
  sentryTest: {
    title: 'Sentry Test',
    fullPath: '/:companyId/sentry-test',
    pattern: {
      path: '/:companyId/sentry-test',
    },
  },
  sharedObjects: {
    title: 'Shared objects',
    fullPath: '/objects/:preSignedUrlKey',
    pattern: {
      path: 'objects/:preSignedUrlKey',
    },
  },
  notFound: {
    title: 'Not Found',
    fullPath: '*',
    pattern: {
      path: '*',
    },
  },
});
